import { useTranslation } from 'react-i18next'


import { useAuth } from '@features/auth'
import { useAddressStore } from '@features/shipping-methods'

import { ProductCarousel } from '@widgets/product-carousel'


import { URL_CATEGORY_PREVIOUSLY_ORDERED } from '@shared/contants'
import { Product, usePreviouslyOrderedProductsQuery } from '@shared/generated'





export default function ProductsPreviouslyOrderedCarousel () {
  const { t: tp } = useTranslation('product')
  const { shopId } = useAddressStore()
  const { isAuthorized } = useAuth()

  const {
    data: previouslyOrderedProductsData,
    loading: loadingOrderedProducts
  } = usePreviouslyOrderedProductsQuery({
    variables: {
      shopId,
      pager: {
        limit: 20,
        page: 1,
      }
    },
    skip: !isAuthorized || !shopId
  })

  if (!isAuthorized) {
    return null
  }

  return (
    <ProductCarousel
      link={URL_CATEGORY_PREVIOUSLY_ORDERED}
      title={tp('previouslyOrdered')}
      products={previouslyOrderedProductsData?.previouslyOrderedProducts?.edges as Product[] || []}
      loading={loadingOrderedProducts}
    />
  )
}